import * as types from "containers/timeTableLectures/ActionType";

const initialState = {
    selectedLectures: "",
}

export const changeSelectedLectures = (payload) => ({type: types.SELECTED_LECTURES_DSP_NMORD, payload});

export default function timeTableReducer(state = initialState, action) {
    switch (action.type) {
        case types.SELECTED_LECTURES_DSP_NMORD:
            return {
                ...state,
                selectedLectures: action.payload
            }
        default:
            return state;
    }
}